/**
 * @fileoverview > handler for the "/engagement/api/segment_cohorts" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementApiSegmentCohortsCacheKeys } from "../engagementApiSegmentCohorts/constants";
import type { SegmentCohortList } from "./types";

export const createSegmentCohort = reactQueryMutationAdapter(
  engagementApiSegmentCohortsCacheKeys,
  (props: SegmentCohortList): Promise<SegmentCohortList> => {
    return fetch(
      "/engagement/api/segment_cohorts",
      "POST",
      { segment_cohorts: props.segment_cohorts },
      {},
      { propagateFetchRequestError: false }
    );
  }
);
